// @todo 2017-09-21 The same function is defined in flux/Store, consider a refactor
// https://github.com/github/fetch#handling-http-error-statuses
function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  let error = new Error(response.statusText);
  error.response = response;
  throw error;
}

/**
 *
 */
class Helpers {
  /**
   * @see http://www.jacklmoore.com/notes/rounding-in-javascript/
   */
  static roundNumber(value, decimals = 2) {
    return Number(`${Math.round(value + 'e' + decimals)}e-${decimals}`).toFixed(decimals);
  }

  static arrayChunk(items, chunkSize) {
    return items.reduce((carry, item, index) => {
      const chunkIndex = Math.floor(index / chunkSize);

      if (carry[chunkIndex]) {
        carry[chunkIndex].push(item);
      } else {
        carry[chunkIndex] = [item];
      }

      return carry;
    }, []);
  }

  static imageToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onloadend = () => {
        resolve(reader.result);
      };

      reader.onerror = reject;

      reader.readAsDataURL(file);
    });
  }

  static resizeImage(base64, width, height, criteria = 'contain') {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    canvas.width = width;
    canvas.height = height;

    const image = new Image();
    image.src = base64;

    return new Promise((resolve, reject) => {
      image.onload = function() {
        const ratio = Math.min(width / this.naturalWidth, height / this.naturalHeight);

        context.drawImage(
          this,
          (width - this.naturalWidth * ratio) / 2,
          (height - this.naturalHeight * ratio) / 2,
          this.naturalWidth * ratio,
          this.naturalHeight * ratio
        );

        return resolve(canvas.toDataURL('image/png'));
      }
    });
  }

  static resizeImageToBase64(file, width, height, criteria = 'contain') {
    return imageToBase64(file)
      .then(base64 => Helpers.resizeImage(base64, width, height, criteria));
  }

  static async base64ToFile(base64, sliceSize = 512) {
    // "data:image/png;base64,JHIGtbao87sdtDAsr…" -> ["data:image/png;base64", "JHIGtbao87sdtDAsr…"]
    const [prefix, base64Data] = base64.split(',');

    // "data:image/png;base64" -> "image/png"
    const contentType = prefix.replace(/data:|;base64/g, '');

    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }

  static thronImageUrl(url, width = 512, height = 512) {
    return url
      .replace('[:width:]', width)
      .replace('[:height:]', height);
  }

  static randomString() {
    return Math.random().toString(36).substring(7);
  }

  static randomId() {
    return Math.floor(100000000 + Math.random() * 900000000);
  };
}

export let
  roundNumber = Helpers.roundNumber,
  arrayChunk = Helpers.arrayChunk,
  imageToBase64 = Helpers.imageToBase64,
  base64ToFile = Helpers.base64ToFile,
  resizeImage = Helpers.resizeImage,
  resizeImageToBase64 = Helpers.resizeImageToBase64,
  thronImageUrl = Helpers.thronImageUrl,
  randomString = Helpers.randomString,
  randomId = Helpers.randomId;



// WEBPACK FOOTER //
// ./src/Helpers.js